export const saveDashboardSettings = (dashboardKey, data) => {
    const existing = JSON.parse(localStorage.getItem('dashboardSettings') || '{}')
    existing[dashboardKey] = { ...existing[dashboardKey], ...data }
    localStorage.setItem('dashboardSettings', JSON.stringify(existing))
}

export const getDashboardSettings = (dashboardKey) => {
    const existing = JSON.parse(localStorage.getItem('dashboardSettings') || '{}')
    return existing[dashboardKey] || {}
}
